module.exports = __webpack_public_path__ + "img/python.cf0678a0.png";